import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetAnnouncement = (announcementContentGuid: string, isAuthenticated: boolean) => {
    return useQuery({
        queryKey: ['get-announcement', announcementContentGuid],
        queryFn: async () => {
            const response = await _apiClient.getAnnouncement(announcementContentGuid);

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve Announcement.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: isAuthenticated && announcementContentGuid !== '',
    });
};
